import {useNavigate} from "react-router-dom";
import React from "react";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @Description Button Large Transparent
 * @param String id: Identifier for the Button (required)
 * @param String url: Url for go (optional)
 * @param String text: Text for the button (required)
 * @param Event click: onClick trigger in the Button (optional)
 * @returns {JSX.Element}
 */

export const ButtonLargeTransparent =  ({id, url, text="", click = null, className='btn-icon-hover-grey btn-large-transparent', icon = null,
  iconColor = 'font-color-shades-300',  disabled = false }) => {
    const navigate = useNavigate();
    return <button id={id} disabled={disabled} onClick={() => {
        if(click !== null) click();
        if (!disabled) navigate(url);
        navigate(url)
    }} className={` ${className} d-flex justify-content-between`}>
        <span className="spn-title align-self-center">{text}</span>
        <span className={`icn align-self-center ${iconColor}`}>  {icon ? icon : <i className="fa fa-plus" aria-hidden="true"></i>}</span>
    </button>
}
